// extracted by mini-css-extract-plugin
export var badge = "_he-2";
export var detailsPanel = "_he-0";
export var resultRow = "_he-1";